.textarea {
  min-height: 120px;
  resize: vertical;
}
